import React from "react";
import { STORAGE_ASSETS } from "../../Const/BaseUrlConst";

type MenuProps = React.HTMLAttributes<HTMLDivElement> & {};

export const Menu: React.FC<MenuProps> = ({ ...props }) => {
  return (
    <div {...props}>
      <img src={STORAGE_ASSETS+"/images/svg/menu.svg"} alt="" />
    </div>
  );
};